import React, {useEffect, useRef, useState} from 'react';
import './Marquee.css';

const Marquee = ({ text, speed = 50 }) => {
  const marqueeRef = useRef(null);
  const containerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const marqueeWidth = marqueeRef.current.scrollWidth;
    const containerWidth = containerRef.current.clientWidth;
    setIsOverflowing(marqueeWidth > containerWidth);
  }, [text]);

  return (
      <div className="marquee-container" ref={containerRef}>
        <div
            className={`marquee ${isOverflowing ? 'marquee--animated' : ''}`}
            ref={marqueeRef}
            style={{ animationDuration: `${speed}s` }}
        >
          {text}
        </div>
      </div>
  );
};

export default Marquee;